module.exports = __webpack_public_path__ + "img/sold_house.cce75f07.svg";